import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/runner/work/apollo/apollo/packages/core/ui/src/atoms/link/link.tsx");
